import { Navigate } from "react-router-dom";
import ResidentLayout from "../layouts/ResidentLayout";

export default function ProtectedResidentRoute({ children }) {
  const token = localStorage.getItem("residentToken");
  const status = localStorage.getItem("residentStatus");

  if (!token) {
    return <Navigate to="/resident/login" replace />;
  }

  if (status !== "approved") {
    return <Navigate to="/resident/pending" replace />;
  }

  return <ResidentLayout>{children}</ResidentLayout>;
}